import { createFileRoute } from "@tanstack/react-router";
import { AbroadGuestStart } from "@/components/abroad/AbroadGuestStart";
import { guestStartHead } from "@/components/abroad/abroad-guest-head";
import { getEduCountriesCount, type CountriesHead } from "@/lib/edu-countries-count.functions";

// Старт подбора без кабинета (az). «_» после xaricde-tehsil — не вкладывать
// в лендинг: у него нет <Outlet/>, и вложенная страница не отрисовалась бы.
export const Route = createFileRoute("/az/xaricde-tehsil_/start")({
  loader: async (): Promise<CountriesHead | null> => {
    try {
      return await getEduCountriesCount();
    } catch {
      return null;
    }
  },
  head: ({ loaderData }) => guestStartHead("az", loaderData),
  component: () => <AbroadGuestStart lang="az" />,
});
